import React from "react";

import events from "common/events";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import IconView from "common/views/icon/Icon.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { Intent, IntentProvider } from "core/components/IntentContext";
import { IPanelProps, Panel } from "core/decorators/Panel";
import UrlUtil from "core/util/UrlUtil";
import TokenSession from "../../core/util/session/TokenSession";
import labelProvider from './Catalog.labels';
import CartLinkPanelConfig from "./config/CartLinkPanelConfig";

const { Labels } = labelProvider;

@Panel({ id: 'cart-link', configClass: CartLinkPanelConfig, labelProvider})
class CartLinkPanel extends React.PureComponent<IPanelProps<CartLinkPanelConfig>, {count: number, cost: number, loading: boolean}> {

	public constructor(props: IPanelProps<CartLinkPanelConfig>) {
		super(props);
		this.state = { count: 0, cost: 0, loading: true };
	}

	public componentDidMount() {
		// listen for the buy event
		if (this.props.cartItems && !this.props.cartItems.length) {
		this.getCartDetails();

		window.addEventListener(events.CartUpdated.type, () => {
			setTimeout(() => {
				this.setState({loading: true}, () => {
					this.getCartDetails();
				});
			}, 500);
		});
	}
	}

	private getCartDetails() {
		fetch(UrlUtil.getAuthorizedLink(TokenSession.getToken(), "catalog/cart/summary?format=json"), {
			credentials: 'include', // <- this is mandatory to deal with cookies
		})
			.then((response) => response.json())
			.then((data) => {
				this.setState({...data, loading: false});
			});
	}

	public render() {
		const { config, cartItems } = this.props;
		const { count, cost, loading } = this.state;

		const itemsCount = cartItems && cartItems.length;
		let itemsCost = 0;
		itemsCount && cartItems.map((item) => {
			item.variants.map((i) => {
				itemsCost = itemsCost + i.price;
			})
		})

		if (config.hideWhenEmpty && count < 1 && !itemsCount) {
			return null;
		}


		return (
			<IntentProvider intent={loading && Intent.LOADING}>
				<PageLinkView viewKey="cart.link">
					<ButtonView variant={ButtonVariant.PRIMARY} viewKey="cart-button">
						<IconView icon="shopping-cart" viewKey="cart-button.icon">
							{itemsCount && itemsCost ? (
								<Labels.CartItemsSummary args={{ itemsCount, itemsCost }} /> //for new cart checkout feature
							) : (<Labels.CartSummary args={{ count, cost }} />) //for existing cart checkout feature
							}
						</IconView>
					</ButtonView>
				</PageLinkView>
			</IntentProvider>
		);
	}

}



// WEBPACK FOOTER //
// ./src/panels/catalog/CartLink.panel.tsx